(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("tagsDataService", tagsDataService);

    tagsDataService.$inject = ['tagsEventsDataService', '$modal', 'brandServices', '$q', 'userPermissions', 'hUser', '$filter'];

    function tagsDataService(tagsEventsDataService, $modal, brandServices, $q, userPermissions, hUser, $filter) {
        var self = this;
        self.TAGS_LABEL_MAP = {
            'GLOBAL': {
                label: $filter('translate')('Global'),
                placeholder: $filter('translate')('Search for global tags')
            },
            'STATUS': {
                label: $filter('translate')('Status'),
                placeholder: $filter('translate')('Search for status tags')
            },
            'GENERAL': {
                label: $filter('translate')('General'),
                placeholder: $filter('translate')('Search for general tags')
            },
            'LOCAL': {
                label: $filter('translate')('Local'),
                placeholder: $filter('translate')('Search for local tags')
            },
            'PRIVATE': {
                label: $filter('translate')('Private'),
                placeholder: $filter('translate')('Search for private tags')
            },
            'POSITION': {
                label: $filter('translate')('Position'),
                placeholder: $filter('translate')('Search for position tags')
            },
        };
        self._brandTags = {};
        self.TAGS_TYPES = TalentPoolAPI2.TAGS_TYPES;
        self.STATUS_TAGS_NAMES = TalentPoolAPI2.STATUS_TAGS_NAMES;
        self.TAGS_TYPES_TO_TEXT = TalentPoolAPI2.TAGS_TYPES_TO_TEXT;
        self.RECRUITMENT_HUB_SPEEDY = 'RECRUITMENT_HUB_SPEEDY';
        self.ADD_TAG_SOURCES = {
            RECRUITMENT_HUB_SPEEDY: 'RECRUITMENT_HUB_SPEEDY',
            GLOBAL_TAGS_SETTINGS: 'GLOBAL_TAGS_SETTINGS',
            TALENT_POOL: 'TALENT_POOL'
        }
        self.TABS_VALUES = {
            CUSTOM_TAGS: 'CUSTOM_TAGS',
            PRIVATE_TAGS: 'PRIVATE_TAGS',
            STATUS_TAGS: 'STATUS_TAGS',
            SILVER_MEDALIST: 'SILVER_MEDALIST'
        };
        self.TAG_OPTIONS_CATEGORY = {
            SILVER_MEDALIST_STAGE: 'SILVER_MEDALIST_STAGE',
        };
        self.SILVER_MEDALIST_STATUS = {
            ACTIVE: 'ACTIVE',
            ARCHIVED: 'ARCHIVED',
        };

        self.TAG_MODES = {
            STATUS: "STATUS",
            POSITION: "POSITION",
        }

        self.getTagGroup = function (tag) {
            if (tag.is_private && tag.mode != 'POSITION') {
                return self.TAGS_TYPES.PRIVATE;
            } else if (self.TAGS_TYPES[tag.mode]) {
                return self.TAGS_TYPES[tag.mode];
            } else {
                return tag.mode;
            }
        };

        var groupTags = function (tags) {
            var tempTags = {};

            tags.forEach(function (tag) {
                var group = self.getTagGroup(tag);
                if (!tempTags[group]) {
                    tempTags[group] = [];
                }
                tempTags[group].push(tag);
            });
            return tempTags;
        };

        self.canManageGlobalTags = function (brandId) {
            var defer = $q.defer();
            var highestLevelBrandType = hUser.getUserHighestBrandAccess().type;
            if (!hUser.isTopLevelContext() && ['enterprise', 'brand'].indexOf(highestLevelBrandType) == -1) {
                defer.resolve(false);
            } else {

                var promises = {};

                promises['globalTalentPoolServiceEnabled'] = brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, brandId);
                promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
                promises['GPs'] = GPSAPI.getGP(brandId);

                $q.all(promises)
                    .then(function (res) {
                        var canManageGlobalTags = res.globalTalentPoolServiceEnabled && res.GPs.id === res.GPs.parent_id &&
                            res.policyParser.has(userPermissions.PERMISSIONS.MANAGE_GLOBAL_TAGS);
                        defer.resolve(canManageGlobalTags);
                    })
                    .catch(function (err) {
                        defer.reject(err);
                        console.error(err);
                    });
            }
            return defer.promise;
        };

        self.getByBrandId = function (brandId, grouped, payload) {
            var defer = $q.defer();

            if (self._brandTags[brandId]) {
                if (grouped) {
                    defer.resolve(groupTags(self._brandTags[brandId]));
                } else {
                    defer.resolve(self._brandTags[brandId]);
                }
            } else {
                TalentPoolAPI2.getBrandTags(brandId, payload).then(function (resp) {
                    self._brandTags[brandId] = resp.tags;
                    if (grouped) {
                        defer.resolve(groupTags(resp.tags));
                    } else {
                        defer.resolve(resp.tags);
                    }
                }, function (e) {
                    console.error(e);
                    defer.reject(e);
                });
            }

            return defer.promise;
        };

        self.getByCandidatesIds = async (brandId, candidatesIds, onlyTagsId, tagModes, amsFlow) => {
            const batchSize = 100;

            try {
                let allCandidatesTags = [];

                if (candidatesIds.length <= batchSize) {
                    const res = await TalentPoolAPI2.getCandidatesTags(brandId, candidatesIds, onlyTagsId, tagModes, amsFlow);
                    allCandidatesTags = res.candidates || [];
                } else {
                    for (let i = 0; i < candidatesIds.length; i += batchSize) {
                        const batch = candidatesIds.slice(i, i + batchSize);
                        const res = await TalentPoolAPI2.getCandidatesTags(brandId, batch, onlyTagsId, tagModes, amsFlow);
                        allCandidatesTags = allCandidatesTags.concat(res.candidates || []);
                    }
                }

                return allCandidatesTags;
            } catch (err) {
                throw err;
            }
        };

        self.createTag = function (brandId, tag, candidateId) {
            var deferred = $q.defer();
            tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_CREATED_BEFORE, brandId, tag);

            TalentPoolAPI2.createTag(brandId, tag, candidateId)
                .then(function (res) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_CREATED_AFTER, brandId, tag, res);
                    deferred.resolve(res);
                })
                .catch(function (err) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_CREATED_ERROR, brandId, tag, err);
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.updateTag = function (brandId, tag) {
            var deferred = $q.defer();
            tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_UPDATED_BEFORE, brandId, tag);

            TalentPoolAPI2.updateTag(brandId, tag.id, tag)
                .then(function (res) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_UPDATED_AFTER, brandId, tag, res);
                    deferred.resolve(res);
                })
                .catch(function (err) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_UPDATED_ERROR, brandId, tag, err);
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.manageTagsOrder = async (brandId, tagsType, payload) => {
            try {
                const res = await TalentPoolAPI2.applyTagsOrder(brandId, tagsType, payload);
                tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAGS_ORDER_UPDATED, brandId, tagsType, res);
                return res;
            } catch (err) {
                tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAGS_ORDER_UPDATED, brandId, tagsType, err);
                throw err;
            }
        };

        self.deleteTag = (brandId, tag) => {
            const tagId = tag.id;
            var deferred = $q.defer();
            tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_DELETED_BEFORE, brandId, tagId);

            TalentPoolAPI2.deleteTag(brandId, tagId)
                .then(function (res) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_DELETED_AFTER, brandId, tag, res);
                    deferred.resolve(res);
                })
                .catch(function (err) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAG_DELETED_ERROR, brandId, tagId, err);
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.assignTagsToCandidates = function (brandId, candidatesIds, tags, source, applicationId) {
            var deferred = $q.defer();
            tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAGS_ASSIGNED_BEFORE, brandId, candidatesIds, tags, source, applicationId);

            var payload = {
                tag_ids: _.pluck(tags, "id"),
                candidate_ids: candidatesIds
            };

            if (source) {
                payload.source = source;
            }

            if (applicationId) {
                payload.application_id = applicationId;
            }

            TalentPoolAPI2.assignTagsToCandidates(brandId, payload)
                .then(function (res) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAGS_ASSIGNED_AFTER, brandId, candidatesIds, tags, source, applicationId, res);
                    deferred.resolve(res);
                })
                .catch(function (err) {
                    if (err?.message === BrandAPI.PROFILE_TYPES_ERROR_CODES.CANNOT_APPLY) {
                        deferred.reject(err);
                    } else {
                        tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAGS_ASSIGNED_ERROR, brandId, candidatesIds, tags, source, applicationId, err);
                        deferred.reject(err);
                    }
                });

            return deferred.promise;
        };

        self.unassignTagsFromCandidates = function (brandId, candidatesIds, tags) {
            var deferred = $q.defer();

            var payload = {
                tag_ids: _.pluck(tags, "id"),
                candidate_ids: candidatesIds
            };

            TalentPoolAPI2.unassignTagsToCandidates(brandId, payload)
                .then(function (res) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAGS_UNASSIGNED_AFTER, brandId, candidatesIds, tags, res);
                    deferred.resolve(res);
                })
                .catch(function (err) {
                    tagsEventsDataService.emit(tagsEventsDataService.EVENTS.ON_TAGS_UNASSIGNED_ERROR, brandId, candidatesIds, tags, err);
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        //check if tag name exists in local tags
        self.isNameExists = function (brandId, tag) {
            var deferred = $q.defer();
            var payload = {
                name: tag.name
            };
            TalentPoolAPI2.checkTagName(brandId, payload)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.showManageTagsModal = (brandId, tags, tagsType) => {
            const defer = $q.defer();
            $modal({
                controller: 'ManageTagsModalController',
                controllerAs: '$ctrl',
                templateUrl: '../hmodules/talent-pool/modals/manage-tags/manage-tags.modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: () => {
                        return {
                            brandId: brandId,
                            tags: tags,
                            tagsType: tagsType
                        };
                    },
                    onClose: () => {
                        return (data) => {
                            defer.resolve(data);
                        };
                    },
                }
            });
            return defer.promise;
        }

        self.showEditStatusTagModal = (selectedTag, tags, brandId) => {
            const defer = $q.defer();
            $modal({
                controller: 'EditStatusTagModalController',
                controllerAs: '$ctrl',
                templateUrl: '../hmodules/talent-pool/modals/edit-status-tag/edit-status-tag.modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: () => {
                        return {
                            selectedTag: selectedTag,
                            tags: tags,
                            brandId: brandId
                        };
                    },
                    onClose: () => {
                        return (data) => {
                            defer.resolve(data);
                        };
                    },
                    onSave: () => {
                        return (data) => {
                            defer.resolve(data);
                        }
                    },
                }
            });
            return defer.promise;
        }

        self.showAddModal = function (modalData, onHideCallBack) {
            var addGlobalTagModal = {
                controller: 'AddGlobalTagController',
                controllerAs: '$ctrl',
                templateUrl: '../hmodules/talent-pool/modals/add-global-tag/add-global-tag.modal.html',
                show: true,
                backdrop: 'static',
            };

            $modal(angular.extend({}, addGlobalTagModal, {
                resolve: {
                    modalData: function () {
                        return modalData || {};
                    },
                    onHide: function () {
                        return onHideCallBack;
                    }
                }
            }));
        };

        self.askToDeleteTag = function (brandId, tag) {
            var deferred = $q.defer();

            var msg = $filter('translate')('Are you sure you want to delete ') + (tag.name ? ('<b>' + tag.name + '</b>') + ' ' + $filter('translate')('tag') : $filter('translate')('this tag')) + '?' +
            '<br>' + $filter('translate')('The deleted tag will be cleared from all candidates');

            hConfirm({
                title: $filter('translate')('Delete Tag'),
                text: msg,
                confirmButton: $filter("translate")("Delete"),
                cancelButton: $filter("translate")("Cancel"),
                callback: function (confirmed) {
                    if (confirmed) {
                        self.deleteTag(brandId, tag)
                            .then(function (res) {
                                deferred.resolve(res);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                                hAlert({
                                    title: $filter('translate')('Error'),
                                    text: $filter('translate')('Something went wrong!'),
                                    custom_class: 'rejection-templates-error-alert'
                                });
                            });
                    } else {
                        deferred.reject();
                    }
                }
            });
            return deferred.promise;
        };

        self.prepareCandidateTagsViewData = function (tags) {
            var candidateTagsMap = {};

            for (var i = 0; i < tags.length; i++) {
                var tag = tags[i];
                var tagMode = (tag.is_private && tag.mode !== 'POSITION') ? 'PRIVATE' : tag.mode;
                candidateTagsMap[tagMode] = candidateTagsMap[tagMode] || [];
                candidateTagsMap[tagMode].push(tag);
            }

            return candidateTagsMap;
        };

        return self;
    }
}());
